var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169,
    height: 170,
    viewBox: "0 0 169 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 170,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3481",
    "data-name": "Group 3481",
    transform: "translate(-960 -4643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_14",
    "data-name": "Repeat Grid 14",
    transform: "translate(960 4643)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-960 -4643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -4643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-2",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-886 -4643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-3",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -4643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-4",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-812 -4643)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-5",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-960 -4606)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-6",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -4606)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-7",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-886 -4606)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-8",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -4606)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-9",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-812 -4606)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-10",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-960 -4569)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-11",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -4569)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-12",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-886 -4569)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-13",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -4569)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-14",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-812 -4569)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-15",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-960 -4532)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-16",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -4532)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-17",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-886 -4532)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-18",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -4532)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-19",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-812 -4532)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-20",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-960 -4495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-21",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-923 -4495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-22",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-886 -4495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-23",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -4495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-24",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-812 -4495)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120-25",
    "data-name": "Ellipse 120",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(960 4643)",
    fill: "#e1e7fc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotted);
export default __webpack_public_path__ + "static/media/dotted.a49abf0833416e906376bcfbdbae1169.svg";
export { ForwardRef as ReactComponent };